<template>
  <div v-if="isShowContent">
    <i18n v-if="isVariables" :path="calData.display_text" :tag="calTag">
      <template v-for="slot in calData.variables" v-slot:[slot.variable_key]>
        <!-- mail -->
        <a v-if="slot.variable_type === 1" :href="`mailto:${slot.variable_value}`" :style="slot.style">
          {{ $te(slot.variable_text) ? $t(slot.variable_text) : slot.variable_value }}
        </a>

        <!-- tel -->
        <a v-else-if="slot.variable_type === 2" :href="`tel:${slot.variable_value}`" :style="slot.style">
          {{ $te(slot.variable_text) ? $t(slot.variable_text) : slot.variable_value }}
        </a>

        <!-- link -->
        <a v-else-if="slot.variable_type === 3" :href="slot.variable_value" target="_blank" :style="slot.style">
          {{ $te(slot.variable_text) ? $t(slot.variable_text) : slot.variable_value }}
        </a>
      </template>
    </i18n>

    <div v-else>
      {{ $te(calData.display_text) ? $t(calData.display_text) : '' }}
    </div>

    <!-- tip -->
    <div v-if="showTip">
      <a-tooltip placement="topLeft">
        <template #title>
          <I18nLang :data="calData.tips_area.tip_content" tag="p" />
        </template>

        <div class="info-icon" :class="getTipIcon(calData.tips_area.tip_icon_type)" />
      </a-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'I18nLang',
  props: {
    data: {
      default: () => {}
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  data() {
    return {};
  },
  computed: {
    calData() {
      return this.data;
    },
    calTag() {
      return this.tag;
    },
    isShowContent() {
      return this.$te(this.calData?.display_text) || this.$te(this.calData?.display_text, 'en');
    },
    isVariables() {
      return this.calData?.variables?.length || false;
    },
    showTip() {
      return this.calData?.tips_area?.tip_content?.display_text || false;
    }
  },
  methods: {
    getTipIcon(tip_icon_type) {
      switch (tip_icon_type) {
        // notice
        case 0:
          return 'info';
        // question
        case 1:
          return 'question';
        // alert
        case 2:
          return 'alert';
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.info-icon {
  width: 14px;
  height: 14px;
  cursor: pointer;

  &.info {
    background: url(~@/assets/images/payment/common/info.png);
  }
  &.question {
    background: url(~@/assets/images/payment/common/question.png);
  }
  &.alert {
    background: url(~@/assets/images/payment/common/alert.png);
  }
}
a {
  color: $red-orange;
  text-decoration: underline;
  &:hover {
    text-decoration: underline !important;
  }
}
</style>
